import { render } from "./SelectServiceView.vue?vue&type=template&id=89d2d236&scoped=true"
import script from "./SelectServiceView.vue?vue&type=script&lang=js"
export * from "./SelectServiceView.vue?vue&type=script&lang=js"

import "./SelectServiceView.vue?vue&type=style&index=0&id=89d2d236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89d2d236"]])

export default __exports__